import { certifications } from '../../data/content';

export default function Certifications() {
  return (
    <section className="section-tight bg-gradient-to-b from-slate-50 to-white border-t border-gray-100">
      <div className="container-wide">
        <div className="text-center mb-12">
          <span className="inline-block text-sm font-semibold text-primary uppercase tracking-wider mb-3">
            Certifications
          </span>
          <h2 className="text-headline text-text">
            Quality You Can Trust
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {certifications.map((cert, index) => (
            <div
              key={index}
              className="group text-center"
            >
              <div className="bg-white rounded-2xl p-6 shadow-soft border border-gray-100 group-hover:shadow-soft-lg group-hover:border-primary/10 transition-all duration-300 mb-4">
                <div className="h-36 flex items-center justify-center">
                  <img
                    src={`/images/${cert.image}`}
                    alt={cert.title}
                    className="max-h-full max-w-full object-contain opacity-70 group-hover:opacity-100 transition-opacity duration-300"
                  />
                </div>
              </div>
              <h4 className="text-sm font-medium text-text-light whitespace-pre-line leading-relaxed">
                {cert.title}
              </h4>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
